import { enqueueSnackbar } from "notistack";
import { viewFileFromS3 } from "../services/s3Service";

export const getFileFromS3 = async (path, openInNewTab = true) => {
  try {
    const response = await viewFileFromS3(path);

    if (response.status === 200) {
      const fileURL = response.data?.data?.file_url;
      if (!fileURL) {
        enqueueSnackbar("File URL not found", { variant: "error" });
        return;
      }
      if (fileURL && openInNewTab) {
        enqueueSnackbar("Please wait, file is opening...", { variant: "info" });
        window.open(fileURL, "_blank");
      }
    }

    return response;
  } catch (error) {
    console.error("Error fetching file from S3:", error);
    throw error; // Let caller handle error if needed
  }
};
